import script from "./DirectionsListView.vue?vue&type=script&setup=true&lang=ts"
export * from "./DirectionsListView.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__